<template>
   <div class="page">
     <page-header ></page-header>
     
     <div class="banners">
       <div class="join-btn" @click="toBout">
         <div class="t">WE NEED YOU!</div>
         <div class="tt">+ 加入我们，一起向前</div>
       </div>
     </div>

     <div class="c-container">
       <div class="main">
         <div class="tab">
           <div class="li" :class="active == index ? 'on' : ''" v-for="(item,index) in tabs" :key="index" @click="tabFn(index)">{{item}}</div>
         </div>

         <div class="tab-box">
           <div v-if="active == 0" class="item">
             <div class="title"><img src="@/assets/images/j-y-line.jpg">Cocos2dx-lua开发工程师</div>
             <div class="office-datail">
								<div class="salary">
									<ul>
										<li>职位薪水：</li>
										<li>15-25k</li>
									</ul>
									<ul>
										<li>工作年限：</li>
										<li>1-3年</li>
									</ul>
								</div>
								<div class="job-r">
									<h4>岗位职责:</h4>
									<p>
									1.客户端框架的设计和核心功能的实现，能独立设计开发各类游戏模块。<br>
									2.客户端的游戏逻辑、UI和动画的开发。<br>
									3.优质的编码和自我测试能力，对客户端的稳定性、扩展性负责。<br>
									</p>
								</div>
								<div class="qualifications">
									<h4>任职资格：</h4>
									<p>
										1、熟悉Lua语言，2年以上Cocos2dx+Lua框架游戏开发经验。<br>
										2、熟练掌握cocos2dx跨平台（ios, android）的调试。<br>
										3、具备独立思考，分析问题以及解决问题能力。<br>
										4、有强烈的责任心和进取心，能与团队成员良好沟通。<br>
										5、在技术上能够钻研，对最新的程序发展有一定了解和关注 <br>
									</p>
								</div>
							</div>

              <div class="title"><img src="@/assets/images/j-y-line.jpg">java游戏服务器开发工程师</div>
              <div class="office-datail">
								<div class="salary">
									<ul>
										<li>职位薪水：</li>
										<li>15-25k</li>
									</ul>
									<ul>
										<li>工作年限：</li>
										<li>2-3年</li>
									</ul>
								</div>
								<div class="job-r">
									<h4>岗位职责:</h4>
									<p>
									1、参与棋牌游戏项目Java服务端的开发。<br>
									2、优质的编码和自我测试能力，对Java服务端的稳定性、扩展性负责。<br>
									</p>
								</div>
								<div class="qualifications">
									<h4>任职资格：</h4>
									<p>
									1、2年以上JAVA编程经验，有较扎实的JAVA基础知识，能够熟练使用JAVA相关技术（socket，spring）进行独立开发；<br>
									2、熟悉JAVA多线程、并发、线程安全；<br>
									3、熟悉TCP/IP协议，有基于java nio框架开发经验，熟悉Mina、Netty等网络通讯框架；<br>
									4、熟悉Linux/unix常用命令，有基于Tomcat/Weblogic/Nginx等网络服务部署、管理及优化配置经验；<br>
									5、熟悉并发编程，网络IO，基础的算法和数据结构，并对java虚拟机有一定的了解。具备对游戏服务端数据存储的设计能力；<br>
									</p>
								</div>
							</div>
           </div>

           <div v-if="active == 1" class="item">
             <div class="title"><img src="@/assets/images/j-y-line.jpg">暂无招聘</div>
           </div>

           <div v-if="active == 2" class="item">
             <div class="title"><img src="@/assets/images/j-y-line.jpg">棋牌游戏策划</div>
             <div class="office-datail">
                <div class="salary">
                  <ul>
                    <li>职位薪水：</li>
                    <li>8-10k</li>
                  </ul>
                  <ul>
                    <li>工作年限：</li>
                    <li>1-3年</li>
                  </ul>
                </div>
                <div class="job-r">
                  <h4>岗位职责:</h4>
                  <p>
                  1、从事棋牌游戏的前期准备工作，包括方案制定、规则设计、细节实现等；<br>
                  2、制定游戏规划方案，编写策划文案，能够保证策划案在项目中正确实施；<br>
                  3、负责棋牌游戏内容和功能的创意、可玩性、操作性的策划工作；<br>
                  4、棋牌游戏的后续工作跟进，包括数据收集分析、产品调整、突发问题的处理等；<br>
                  5、收集整理用户建议及产品缺陷，提出意见，推动产品质量持续改善；<br>
                  </p>
                </div>
                <div class="qualifications">
                  <h4>任职资格：</h4>
                  <p>
                  1、1年以上游戏策划经验，最少1款棋牌类游戏策划经验；<br>
                  2、熟悉主流游戏的流程及各个环节，熟悉网络游戏市场，对行业发展有清晰认识；<br>
                  3、熟悉主流棋牌游戏规则、系统和逻辑等，有一定程序和美术的设计概念，有一定量化、体系化、宏观的数值策划能力；对棋牌比赛系统有实践及想法；<br>
                  4、对数据有敏感性，能够进行数据挖掘分析；<br>
                  5、兴趣广泛，热爱游戏，游戏经验丰富，熟悉各种游戏、特别对棋牌类网络休闲游戏有相当程度的认识及感悟；深入了解游戏可玩性； <br>
                  6、有良好的文字功底，良好的沟通协调能力，良好的团队合作意识。<br>
                  </p>
                </div>
              </div>
           </div>

           <div v-if="active == 3" class="item">
             <div class="title"><img src="@/assets/images/j-y-line.jpg">暂无招聘</div>
           </div>


           <div v-if="active == 4" class="item">
             <div class="title"><img src="@/assets/images/j-y-line.jpg">暂无招聘</div>
           </div>

           <div v-if="active == 5" class="item">
             <div class="title"><img src="@/assets/images/j-y-line.jpg">暂无招聘</div>
           </div>

         </div>

       </div>
      </div>
     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     tabs : ['技术','产品','运营','行政','营销','美术'],
     active : 0,
    }
  },
  created () {
  },
  mounted () {
  },
  
  methods: {
    tabFn(e){
      this.active = e;
    },
    toBout(){
      let path = `/about`
      this.$router.push({
          path
      })
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  max-width: 512px;
  margin: 0 auto;
  position: relative;
}

.banners{
  height: 175px;
  background: url(../../assets/images/join-banner.jpg) no-repeat center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.join-btn{
    width: 192px;
    height: 50px;
    padding: 10px 0;
    box-sizing: border-box;
    border: 1px solid rgba(255,255,255,1);
    opacity: 0.4;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    font-size: 10px;
    color: #fff;
    cursor: pointer;
    .t{
      width: 100%;
      text-align: center;
      height: 12px;
    }
    .tt{
      height: 12px;
    }
    &:hover{
      opacity: 1;
    }
}

.c-container{
	width: 100%;
  padding-top: 15px;
  .tab{
    width: 100%;
    height: 38px;
    display: flex;
    margin-bottom: 15px;
    box-shadow: 0px 5px 5px #ddd;
    .li{
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      box-sizing: border-box;
      border-right: 1px solid #f3f3f3;
      &.on{
        background: #000;
        color: #fff;
      }
      &:hover{
        background: #000;
        color: #fff;
      }
    }
  }
  .tab-box{
    .title{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img{
        width: 5px;
        height: auto;
        margin-right: 6px;
      }
    }
  }
}

.office-datail{
	width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;
	color: #333;
	padding: 10px;
	border: 1px solid #ccc;
	box-shadow: 0 3px 3px #ddd;
}
.office-datail .salary{
	margin-top: 5px;
}
.office-datail .salary ul{
	float: left;
	font-family: "微软雅黑";
	font-size: 10px;
	color: #000;
	font-weight: 600;
}
.office-datail .salary ul li{
	float: left;
	margin-right: 10px;
}
.office-datail .job-r{
	margin-top: 30px;
	font-family: "微软雅黑";
	font-size: 8px;
	color: #666;
}
.office-datail .job-r h4{
	font-family: "微软雅黑";
	font-size: 10px;
	color:#000;
	font-weight: 600;
}
.office-datail .job-r p{
	margin-top: 15px;
	line-height: 18px;
}
.office-datail .qualifications{
	margin-top: 15px;
  font-size: 8px;
}
.office-datail .qualifications h4{
	font-family: "微软雅黑";
	font-size: 10px;
	color:#000;
	font-weight: 600;
}
.office-datail .qualifications p{
	margin-top: 15px;
	line-height: 18px;
}





@media (max-width:800px) {
  .c-container{
    
  }
}

</style>
